/**
 * Get profile URL for a messaging participant based on their role
 *
 * @param participant - User summary with id, role, and (for providers) providerId
 * @returns Profile URL string or null if no profile page exists
 */
export function getProfileUrl(participant: {
  id: string;
  role: 'CARE_SEEKER' | 'SERVICE_PROVIDER' | 'FINANCIAL_ADVISOR';
  providerId?: string;
}): string | null {
  switch (participant.role) {
    case 'SERVICE_PROVIDER':
      // The /providers/:id route resolves by service_providers.id, not user.id.
      return participant.providerId
        ? `/providers/${participant.providerId}?discoverySource=MESSAGES`
        : null;
    case 'FINANCIAL_ADVISOR':
      // TODO: Update when FP profiles are implemented
      return null;
    case 'CARE_SEEKER':
      return null;
    default:
      return null;
  }
}

/**
 * Check if participant has a clickable profile
 *
 * @param participant - User summary with id and role
 * @returns True if participant has a public profile page
 */
export function hasClickableProfile(participant: {
  id: string;
  role: 'CARE_SEEKER' | 'SERVICE_PROVIDER' | 'FINANCIAL_ADVISOR';
  providerId?: string;
}): boolean {
  return getProfileUrl(participant) !== null;
}
